import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap ep"
}
const _hoisted_2 = { class: "ep-layout" }
const _hoisted_3 = { class: "ep-main" }
const _hoisted_4 = { class: "ep-fmt-where" }
const _hoisted_5 = { class: "ep-paper" }
const _hoisted_6 = { class: "cl-days" }
const _hoisted_7 = { class: "cl-days-btns" }
const _hoisted_8 = ["aria-pressed", "onClick"]
const _hoisted_9 = { class: "cl-sec-h" }
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24"
}
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 24 24"
}
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "cl-gh" }
const _hoisted_14 = {
  key: 0,
  class: "cl-ic",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = {
  key: 1,
  class: "cl-ic",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = {
  key: 2,
  class: "cl-main cl-note-body"
}
const _hoisted_17 = {
  key: 3,
  class: "cl-main"
}
const _hoisted_18 = ["onUpdate:modelValue", "data-cl"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "cl-tools" }
const _hoisted_21 = ["value", "onChange"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["title", "onClick"]
const _hoisted_27 = {
  key: 0,
  viewBox: "0 0 24 24"
}
const _hoisted_28 = {
  key: 1,
  viewBox: "0 0 24 24"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "cl-adds" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "cl-empty"
}
const _hoisted_35 = {
  key: 1,
  class: "cl-start"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_bar = _resolveComponent("editor-bar")!
  const _component_tip_tap_toolbar = _resolveComponent("tip-tap-toolbar")!
  const _component_editor_doc_head = _resolveComponent("editor-doc-head")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_editor_activity = _resolveComponent("editor-activity")!
  const _component_editor_details_drawer = _resolveComponent("editor-details-drawer")!
  const _component_editor_save_dialog = _resolveComponent("editor-save-dialog")!
  const _component_editor_discard_dialog = _resolveComponent("editor-discard-dialog")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_ai_improve_panel = _resolveComponent("ai-improve-panel")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_editor_bar, {
          name: _ctx.node.Name,
          version: _ctx.node.Version,
          dirty: _ctx.dirty,
          "type-label": "checklist",
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSave())),
          onHeight: _cache[3] || (_cache[3] = ($event: any) => (_ctx.barHeight = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ai-btn pb-btn",
              title: "Improve with AI",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAIModal = true))
            }, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                class: "ep-fill"
              }, [
                _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
              ], -1),
              _createElementVNode("span", null, "Improve with AI", -1)
            ]))])
          ]),
          _: 1
        }, 8, ["name", "version", "dirty"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["ep-fmt", { live: _ctx.activeEditor }]),
                style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.activeEditor ? 'Note' : 'Click into a note to format it'), 1),
                (_ctx.activeEditor)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ep-fmt-btns",
                      onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.keepEditorFocus && _ctx.keepEditorFocus(...args)))
                    }, [
                      _createVNode(_component_tip_tap_toolbar, {
                        editor: _ctx.activeEditor,
                        "show-align": true
                      }, null, 8, ["editor"])
                    ], 32))
                  : _createCommentVNode("", true)
              ], 6),
              _createElementVNode("article", _hoisted_5, [
                _createVNode(_component_editor_doc_head, {
                  locs: _ctx.locs,
                  deps: _ctx.deps,
                  types: _ctx.types,
                  "owner-names": _ctx.ownerNames,
                  version: _ctx.node.Version,
                  onOpen: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetails = true))
                }, null, 8, ["locs", "deps", "types", "owner-names", "version"]),
                _createElementVNode("section", _hoisted_6, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "cl-days-h" }, "Days it runs", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DAY_ORDER, (d) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: d,
                        type: "button",
                        class: _normalizeClass(['ep-chip', { on: _ctx.runsOn(d) }]),
                        "aria-pressed": _ctx.runsOn(d),
                        onClick: ($event: any) => (_ctx.toggleDay(d))
                      }, _toDisplayString(_ctx.DAY_SHORT[d]), 11, _hoisted_8))
                    }), 128))
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("p", null, "Missed-powerlist summaries to managers skip the days it doesn't run.", -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: list.key,
                    class: "cl-sec"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", null, [
                        (list.key == 'items')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "4"
                              }, null, -1),
                              _createElementVNode("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("path", { d: "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM16 3v4M8 3v4M4 11h16M8 15h2v2H8z" }, null, -1)
                            ]))])),
                        _createTextVNode(" " + _toDisplayString(list.title) + " ", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.taskCount(list.key)) + " task" + _toDisplayString(_ctx.taskCount(list.key) == 1 ? '' : 's'), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(list.hint), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsOf(list.key), (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: String(group.key),
                        id: 'cl-group-' + list.key + '-' + group.key,
                        class: "cl-group"
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createTextVNode(_toDisplayString(group.label), 1),
                          _createElementVNode("span", null, _toDisplayString(group.rows.filter(r => r.item.type != 'textblock').length), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row, k) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: row.item.id,
                            class: _normalizeClass(['cl-row', { 'cl-note': row.item.type == 'textblock' }])
                          }, [
                            (row.item.type == 'textblock')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "9"
                                  }, null, -1),
                                  _createElementVNode("path", { d: "M12 8h.01M11 12h1v4h1" }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[28] || (_cache[28] = [
                                  _createElementVNode("rect", {
                                    x: "4",
                                    y: "4",
                                    width: "16",
                                    height: "16",
                                    rx: "3"
                                  }, null, -1)
                                ]))])),
                            (row.item.type == 'textblock')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_tip_tap, {
                                    modelValue: row.item.text,
                                    "onUpdate:modelValue": ($event: any) => ((row.item.text) = $event),
                                    "hide-toolbar": true,
                                    "show-align": true,
                                    onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeEditor = $event))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((row.item.label) = $event),
                                    "data-cl": row.item.id,
                                    class: "cl-title",
                                    placeholder: "Task"
                                  }, null, 8, _hoisted_18), [
                                    [_vModelText, row.item.label]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((row.item.description) = $event),
                                    class: "cl-desc",
                                    placeholder: "Details (optional)"
                                  }, null, 8, _hoisted_19), [
                                    [_vModelText, row.item.description]
                                  ])
                                ])),
                            _createElementVNode("span", _hoisted_20, [
                              _createElementVNode("select", {
                                class: "cl-move",
                                value: _ctx.groupKeyOf(list.key, row.item),
                                "aria-label": 'Move to',
                                onChange: ($event: any) => (_ctx.moveToGroup(list.key, row.index, ($event.target as HTMLSelectElement).value))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moveOptions(list.key, row.item), (g) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: String(g.key),
                                    value: String(g.key)
                                  }, _toDisplayString(g.label), 9, _hoisted_22))
                                }), 128))
                              ], 40, _hoisted_21),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move up",
                                disabled: k == 0,
                                onClick: ($event: any) => (_ctx.moveWithin(list.key, group, k, -1))
                              }, [...(_cache[29] || (_cache[29] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 15l6-6 6 6" })
                                ], -1)
                              ]))], 8, _hoisted_23),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move down",
                                disabled: k == group.rows.length - 1,
                                onClick: ($event: any) => (_ctx.moveWithin(list.key, group, k, 1))
                              }, [...(_cache[30] || (_cache[30] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                                ], -1)
                              ]))], 8, _hoisted_24),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                title: "Duplicate",
                                "aria-label": "Duplicate",
                                onClick: ($event: any) => (_ctx.duplicate(list.key, row.index))
                              }, [...(_cache[31] || (_cache[31] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V9zM5 15H4a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v1" })
                                ], -1)
                              ]))], 8, _hoisted_25),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                title: _ctx.copiedID == row.item.id ? 'Copied' : 'Copy (paste into any checklist)',
                                "aria-label": "Copy",
                                onClick: ($event: any) => (_ctx.copyItem(row.item))
                              }, [
                                (_ctx.copiedID == row.item.id)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [...(_cache[32] || (_cache[32] = [
                                      _createElementVNode("path", { d: "M5 12.5l4.5 4.5L19 7.5" }, null, -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[33] || (_cache[33] = [
                                      _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 3h6v4H9z" }, null, -1)
                                    ]))]))
                              ], 8, _hoisted_26),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon del",
                                "aria-label": "Delete",
                                onClick: ($event: any) => (_ctx.remove(list.key, row.index))
                              }, [...(_cache[34] || (_cache[34] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                                ], -1)
                              ]))], 8, _hoisted_29)
                            ])
                          ], 2))
                        }), 128)),
                        _createElementVNode("div", _hoisted_30, [
                          (group.key !== _ctx.NO_DAY)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: ($event: any) => (_ctx.addTask(list.key, group.key))
                              }, [...(_cache[35] || (_cache[35] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                                ], -1),
                                _createTextVNode("Add task", -1)
                              ]))], 8, _hoisted_31))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.addNote(list.key, group.key))
                          }, [...(_cache[36] || (_cache[36] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M5 4h14v16H5zM9 8h6M9 12h6M9 16h3" })
                            ], -1),
                            _createTextVNode("Add note", -1)
                          ]))], 8, _hoisted_32),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.pasteItem(list.key, group.key))
                          }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 3h6v4H9zM9 12h6M9 16h4" })
                            ], -1),
                            _createTextVNode("Paste", -1)
                          ]))], 8, _hoisted_33)
                        ])
                      ], 8, _hoisted_12))
                    }), 128)),
                    (!_ctx.groupsOf(list.key).length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(list.empty), 1))
                      : _createCommentVNode("", true),
                    (_ctx.unusedGroups(list.key).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("span", null, _toDisplayString(list.key == 'items' ? 'Add tasks for' : 'Add a task on'), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unusedGroups(list.key), (g) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: String(g.key),
                              type: "button",
                              class: "ep-chip",
                              onClick: ($event: any) => (_ctx.addTask(list.key, g.key))
                            }, [
                              _cache[38] || (_cache[38] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                              ], -1)),
                              _createTextVNode(_toDisplayString(g.label), 1)
                            ], 8, _hoisted_36))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("aside", {
              class: "ep-side",
              "aria-label": "Outline",
              style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: list.key
                }, [
                  _createElementVNode("div", {
                    class: "ep-side-h",
                    style: _normalizeStyle(list.key == 'weeklyItems' ? 'margin-top:14px' : '')
                  }, _toDisplayString(list.title), 5),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsOf(list.key), (group) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: String(group.key),
                      type: "button",
                      class: "ep-ol",
                      onClick: ($event: any) => (_ctx.jumpTo(list.key, group.key))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(group.rows.filter(r => r.item.type != 'textblock').length), 1),
                      _createTextVNode(_toDisplayString(group.label), 1)
                    ], 8, _hoisted_37))
                  }), 128))
                ], 64))
              }), 128)),
              _createVNode(_component_editor_activity, {
                comments: _ctx.comments,
                "signed-count": _ctx.signedCount,
                "required-count": _ctx.requiredSigners.length,
                version: _ctx.node.Version
              }, null, 8, ["comments", "signed-count", "required-count", "version"])
            ], 4)
          ])
        ], 2),
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_editor_details_drawer, {
              key: 0,
              name: _ctx.node.Name,
              "onUpdate:name": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.node.Name) = $event)),
              ownerIds: _ctx.ownerIDs,
              "onUpdate:ownerIds": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ownerIDs) = $event)),
              locs: _ctx.locs,
              "onUpdate:locs": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.locs) = $event)),
              deps: _ctx.deps,
              "onUpdate:deps": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deps) = $event)),
              types: _ctx.types,
              "onUpdate:types": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.types) = $event)),
              "type-label": "checklist",
              onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDetails = false))
            }, null, 8, ["name", "ownerIds", "locs", "deps", "types"]))
          : _createCommentVNode("", true),
        (_ctx.showSave)
          ? (_openBlock(), _createBlock(_component_editor_save_dialog, {
              key: 1,
              status: _ctx.node.NeedsApprovalType,
              "onUpdate:status": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.node.NeedsApprovalType) = $event)),
              version: _ctx.node.Version,
              "required-count": _ctx.requiredSigners.length,
              "signed-count": _ctx.signedCount,
              busy: _ctx.disableButton,
              "note-placeholder": "e.g. Added end-of-shift inventory counts",
              onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showSave = false)),
              onSave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitCheck($event)))
            }, null, 8, ["status", "version", "required-count", "signed-count", "busy"]))
          : _createCommentVNode("", true),
        (_ctx.showDiscard)
          ? (_openBlock(), _createBlock(_component_editor_discard_dialog, {
              key: 2,
              onKeep: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showDiscard = false)),
              onDiscard: _cache[17] || (_cache[17] = ($event: any) => (_ctx.leave()))
            }))
          : _createCommentVNode("", true),
        (_ctx.showAIConfirm)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 3,
              onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submit())),
              onCancel: _cache[19] || (_cache[19] = () => { _ctx.showAIConfirm = false; }),
              msg: _ctx.AIConfirmText
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true),
        (_ctx.showAIModal)
          ? (_openBlock(), _createBlock(_component_ai_improve_panel, {
              key: 4,
              "node-type": "checklist",
              slug: _ctx.node.Slug,
              "current-draft": { name: _ctx.node.Name, items: _ctx.checklistJSON.items },
              onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showAIModal = false)),
              onApply: _cache[21] || (_cache[21] = d => { _ctx.onAIDraft(d); _ctx.showAIModal = true }),
              onAccept: _ctx.onAIDraft
            }, null, 8, ["slug", "current-draft", "onAccept"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}